module.exports = __webpack_public_path__ + "img/pasture_panicum_middle.50d785aa.jpg";